











































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Summary extends Vue {
  list = [
    {
      title: "知识：",
      desc:
        "认证不仅使人们获取知识有了明确的目标，更令知识获取具备了清晰的通道和阶梯。"
    },
    {
      title: "技能：",
      desc:
        "华为认证基于岗位能力模型进行设计，不仅包含知识，同样注重技能。认证学习和考试通过上机、实践等多种手段，帮助人才实现技能提升。"
    },
    {
      title: "进步：",
      desc:
        "现代企业愈发重视在任职体系中的应用人才认证，华为在ICT领域的领导地位，更加有力的帮助ICT人才在任职体系中获取更强的竞争力。"
    },
    {
      title: "信任：",
      desc:
        "是否拥有知识和技能，难以显性化 。而认证就像一枚枚荣誉勋章，帮助你赢得雇主、客户和同事宝贵的信任。"
    },
    {
      title: "机会：",
      desc:
        "幸运女神只会眷顾有准备的人。赢得认证，  提升ICT知识技能准备度，意味将打开幸运之门的金钥匙把握在自己的手中。"
    },
    {
      title: "自信：",
      desc:
        "自信是成功的心理保障，而认证，是自信的现实来源。通过自己的不懈努力，赢得认证，能够帮助我们树立起强有力的自信心。"
    }
  ];
  To(e) {
    window.location.href = e;
  }
}
